import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import i18n from '@vue-storefront/i18n';

/**
 * Converts number to price string
 * @param {Number} value
 * @param currencySignOverride
 */
export function price (value, currencySignOverride = null) {
  if (value == null || value === '') {
    return '—';
  }
  if (isNaN(value)) {
    return value;
  }
  let formattedVal = Math.abs(parseFloat(value)).toFixed(2);
  const storeView = currentStoreView();
  if (!storeView.i18n) {
    return value;
  }
  let currencySign = currencySignOverride || storeView.i18n.currencySign;
  const prependCurrency = (price) => {
    return currencySign + price;
  };

  const appendCurrency = (price) => {
    return price + i18n.t(currencySign);
  };

  if (storeView.i18n.currencySignPlacement === 'append') {
    formattedVal = appendCurrency(formattedVal);
  } else {
    formattedVal = prependCurrency(formattedVal);
  }

  if (value > 0) {
    return formattedVal;
  } else if (value <= 0) {
    return i18n.t('Free');
  } else {
    return '-' + formattedVal;
  }
}
